import { generateId } from '@revenuemarket/utils';

import { OverlayOpenCallback } from '../types';
import overlayEventContext from './event';

export const overlays = {
  open: (callback: OverlayOpenCallback) => {
    const id = generateId();
    overlayEventContext.notifyOpen(id, callback);
    return id;
  },
  close: (id: string) => {
    overlayEventContext.notifyClose(id);
  },
};
